import store from '@/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@/views/Home.vue')),
    meta: {
      title: 'Home',
      navbarBlue: true,
      showFooter: true,
    }
  }
]

function lazyLoadView(AsyncView) {
  let AsyncHandler = () => ({
    component: AsyncView,
    delay: 400,
    timeout: 5000
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    }
  })
}
